import React, { lazy, Suspense, useState, useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import { useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import validator from "validator";
import { styled } from "@mui/material/styles";
import { InputAdornment } from "@mui/material";
import { showResMsg } from "utils/generic";

const Editor = lazy(() =>
  import("@tinymce/tinymce-react").then((module) => ({
    default: module.Editor,
  }))
);
const InputContainer = styled(Box)(({ theme }) => ({
  gap: theme.spacing(1),
}));
const modalStyle = (theme) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 650,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "8px",
  [theme.breakpoints.down("sm")]: {
    width: "80%",
  },
  [theme.breakpoints.down("md")]: {
    width: "60%",
  },
  [theme.breakpoints.up("md")]: {
    width: "40%",
  },
});

const textareaContainerStyles = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  width: "100%",
};

const documentAdd = {
  display: "flex",
  flexDirection: "column",
  // gap: '10px',
  padding: "5px 0px",
  width: "100%",
};
const BasicModal = ({ open, handleClose, templatesData, onSend }) => {
  const [values, setValues] = useState({
    selectedID: "",
    screenType: "",
    message: "",
    subject: "",
    emailAddress: "",
  });
  const [chipData, setChipData] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [emailErrTitle, setEmailErrTitle] = useState("");
  const theme = useTheme();
  const inputRef = useRef(null);

  // const [file, setFile] = useState();
  // const [actualFile, setActualFile] = useState();
  // const [fileName, setFileName] = useState("");

  useEffect(() => {
    if (templatesData) {
      setValues({
        selectedID: templatesData.selectedID,
        screenType: templatesData.screenType,
        message: templatesData.emailTemplate.templateMessage,
        subject: templatesData.emailTemplate.templateSubject,
        emailAddress: "",
      });
      setIsChecked(false);
    }
    if (templatesData?.customerEmailAddress.length > 0) {
      setChipData(
        templatesData.customerEmailAddress.map((email, index) => ({
          key: index,
          label: email,
        }))
      );
    }
  }, [templatesData]);
  const handleKeyPress = (event) => {
    const inputValue = event.target.value.trim();
    if (event.key === "Enter" && inputValue !== "") {
      if (!validator.isEmail(inputValue)) {
        setEmailErrTitle("Please enter a valid email address");
        return;
      } else {
        setEmailErrTitle("");
        const isDuplicate = chipData.some((chip) => chip.label === inputValue);
        if (!isDuplicate) {
          setEmailErrTitle("");
          setChipData([
            ...chipData,
            { key: chipData.length, label: inputValue },
          ]);
          setValues({ ...values, emailAddress: "" });
        } else {
          setEmailErrTitle("Duplicate error: Email Address already added.");
        }
      }
    }
  };
  const handleChange = (name) => (event) => {
    const inputValue = event.target.value;
    setValues({ ...values, [name]: inputValue });
  };

  const handleDelete = (chipToDelete) => () => {
    setChipData((chips) =>
      chips.filter((chip) => chip.key !== chipToDelete.key)
    );
  };

  const handleEditorChange = (content) => {
    setValues({ ...values, message: content });
  };

  const handleCheckbox = (event) => {
    setIsChecked(event.target.checked);
  };
  // const saveFile = (e) => {
  //     try {
  //         const fileInput = e.target;
  //         const file = fileInput.files[0];
  //         if (file) {
  //             let fileSizeInMB = file.size / (1024 * 1024);
  //             if (fileSizeInMB > 1) {
  //                 showResMsg(`File can't be blank or more than 1 MB`, 2000, false);
  //             } else {
  //                 setFile(URL.createObjectURL(file));
  //                 setActualFile(file);
  //                 setFileName(file.name);
  //                 // const reader = new FileReader();
  //                 // reader.onloadend = () => {
  //                 //     setShowImageFlag(false);
  //                 //     // setShowEYEBtn(true);
  //                 // };
  //                 // reader.readAsDataURL(file);
  //             }
  //         } else {
  //             // Handle the case when no file is selected
  //             setFile(null);
  //             setActualFile(null);
  //             setFileName('');
  //             // setShowEYEBtn(false);
  //         }
  //         // Reset the file input value to allow re-selection of the same file
  //         fileInput.value = null;
  //     } catch (error) {
  //         console.log("Catch in saveFile=", error);
  //     }
  // };

  const handleSend = () => {
    const emailContent = {
      sendMeCopy: isChecked,
      customerEmailAddress: chipData.map((chip) => chip.label),
      emailTemplate: {
        templateSubject: values.subject,
        templateMessage: values.message,
      },
      screenType: values.screenType,
      selectedID: templatesData.selectedID,
      userEmailAddress: templatesData.userEmailAddress,
    };
    onSend(emailContent);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      shouldCloseOnOverlayClick={false}
    >
      <Box sx={modalStyle(theme)} style={{ border: "none" }}>
        <div className="dialogTitle">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{ fontWeight: "600" }}
          >
            Send {values.screenType}
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>

        <Typography className="contenttxt">To</Typography>
        <InputContainer>
          <TextField
            variant="outlined"
            className="textEmailTo"
            fullWidth
            // multiline
            // row={1}
            value={values.emailAddress}
            onChange={handleChange("emailAddress")}
            onKeyDown={handleKeyPress}
            ref={inputRef}
            // value={inputValue}
            // onChange={handleChange}
            InputProps={{
              startAdornment: (
                <>
                  {chipData.length > 0 &&
                    chipData.map((data, index) => (
                      <Chip
                        key={index}
                        label={data.label}
                        onDelete={handleDelete(data)}
                        sx={{ margin: theme.spacing(0.5) }}
                      />
                    ))}
                </>
              ),
            }}
            sx={{ padding: "0px" }}
          />
          <span style={{ color: "red", fontSize: "11px" }}>
            {" "}
            {emailErrTitle}
          </span>
        </InputContainer>
        {/* <TextField
                    id="outlined-basic"
                    variant="outlined"
                    fullWidth
                    value={values.emailAddress}
                    onChange={handleChange('emailAddress')}
                    onKeyUp={handleKeyPress}
                    autoFocus
                    sx={{
                        marginTop: '1px',
                        height: '35px',
                        '& .MuiOutlinedInput-root': {
                            height: '40px',
                            '& .MuiInputBase-input': {
                                padding: '0 10px',
                            },
                        },
                    }}
                />
                <span style={{ color: 'red', fontSize: '11px' }}> {emailErrTitle}</span>
                <Box sx={{ display: 'flex', justifyContent: 'start', flexWrap: 'wrap', listStyle: 'none', m: 0, marginTop: '10px', gap: 0.8 }}>
                    {chipData.length > 0 && chipData.map((data, index) => (
                        <Chip
                            key={index}
                            label={data.label}
                            onDelete={handleDelete(data)}
                        />
                    ))}
                </Box> */}

        <Typography className="contenttxt1">Subject</Typography>
        <TextField
          id="outlined-basic"
          variant="outlined"
          fullWidth
          value={values.subject}
          onChange={handleChange("subject")}
          sx={{
            marginTop: "1px",
            height: "35px",
            "& .MuiOutlinedInput-root": {
              height: "40px",
              "& .MuiInputBase-input": {
                padding: "0 14px",
              },
            },
          }}
        />

        <div style={textareaContainerStyles}>
          <Typography className="contenttxt1">Message</Typography>
          <Suspense fallback={<div>Loading editor...</div>}>
            <Editor
              apiKey="your-api-key"
              value={values.message}
              onEditorChange={handleEditorChange}
              init={{
                height: 300,
                menubar: false,
                plugins: [
                  "advlist autolink lists link image charmap print preview anchor",
                  "searchreplace visualblocks code fullscreen",
                  "insertdatetime media table paste code help wordcount",
                ],
                toolbar:
                  "undo redo | formatselect | bold italic backcolor | " +
                  "alignleft aligncenter alignright alignjustify | " +
                  "bullist numlist outdent indent | removeformat | help",
                content_style: `
                                    ::-webkit-scrollbar {
                                        width: 12px;
                                        height: 20px;
                                    }
                                    ::-webkit-scrollbar-thumb {
                                        background: rgba(0, 0, 0, 0.5);
                                        box-shadow: inset 0 0 6px rgba(255, 208, 208, 0.5);
                                    }
                                    ::-webkit-scrollbar-track {
                                        box-shadow: inset 0 0 10px rgb(200, 201, 199);
                                    }
                                `,
              }}
            />
          </Suspense>
        </div>
        {/* <div style={documentAdd}>
                    <Typography className='contenttxtDoc'>Upload Document</Typography>
                    <label htmlFor="fileInput">
                        <TextField
                            type="text"
                            // label="Upload Document"
                            // InputLabelProps={fileName ? { shrink: true } : { shrink: false }}
                            variant="outlined"
                            fullWidth
                            value={fileName}
                            InputProps={{
                                readOnly: true,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <label htmlFor="fileInput">
                                            <Button
                                                variant="contained"
                                                color="dark"
                                                component="span"
                                                size="small"
                                                allign="right"
                                            // style={darkMode ? { color: "black" } : { color: "black" }}
                                            >
                                                Choose File
                                            </Button>
                                        </label>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <input
                            type="file"
                            accept="image/*,.pdf,.docx,.doc,application/vnd.ms-excel"
                            // accept="image/*"
                            id="fileInput"
                            style={{ display: 'none' }}
                            onChange={saveFile}
                        />
                    </label>
                </div> */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
            mt: "10px",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <input
              className="largerCheckbox"
              type="checkbox"
              id="checkBox"
              name="checkBox"
              checked={isChecked}
              onChange={handleCheckbox}
            />
            <label htmlFor="checkBox" className="txtdata">
              Send me a Copy
            </label>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Button
              variant="outlined"
              sx={{
                border: "1px solid lightgray",
                fontWeight: "600",
                color: "#1b73e8",
              }}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{ fontWeight: "600", color: "#ffffff" }}
              onClick={handleSend}
            >
              Send
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default BasicModal;
